import { Component } from '@angular/core';

@Component({
  selector: 'ngx-projets',
  template: `<router-outlet></router-outlet>`,
})
export class ProjetsComponent {
}
